import { useI18n } from 'vue-i18n';
import { defineComponent, ref, computed } from 'vue';
import { OptionMenuItemCallback } from '../options-menu/types/enums/option-menu-item-callback';
import VideoPlayer from '../video/player/components/VideoPlayer.vue';
export default defineComponent({
    components: {
        VideoPlayer,
    },
    props: {
        page: {
            type: Object,
            required: true,
        },
    },
    emits: ['track-video'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const currentVideoPlayTime = ref(null);
        const showOptions = ref(false);
        const thumbUrl = computed(() => { var _a; return (_a = props.page.video) === null || _a === void 0 ? void 0 : _a.thumbUrl; });
        const options = computed(() => [
            {
                icon: 'edit',
                title: t('edit'),
                callback: OptionMenuItemCallback.Edit,
            },
            {
                icon: 'chevron-up-and-down',
                title: t('move'),
                callback: OptionMenuItemCallback.Move,
            },
            {
                icon: 'delete-bin',
                title: t('delete'),
                callback: OptionMenuItemCallback.Delete,
            },
        ]);
        const handleTimeUpdate = (playtime) => {
            currentVideoPlayTime.value = playtime;
        };
        const handlePause = () => {
            sendTrackingData();
        };
        const handleEnded = () => {
            sendTrackingData();
        };
        const handleShowOptions = () => {
            showOptions.value = true;
        };
        const hideOptions = () => {
            showOptions.value = false;
        };
        const sendTrackingData = () => {
            if (!currentVideoPlayTime.value) {
                return;
            }
            emit('track-video', { id: props.page.video.id, viewDuration: currentVideoPlayTime.value });
            currentVideoPlayTime.value = null;
        };
        return {
            currentVideoPlayTime,
            thumbUrl,
            options,
            showOptions,
            handleTimeUpdate,
            handlePause,
            handleEnded,
            handleShowOptions,
            hideOptions,
            sendTrackingData,
        };
    },
});
